import axiosInstance from "./axiosInstance";

export const initiateResetPassword = async (loginId: string) => {
  const res = await axiosInstance.post(
    "/User/reset-password/init",
    { loginId }
  );
  return res.data;
};

export const resendResetOtp = async (loginId: string) => {
  const res = await axiosInstance.post(
    "/User/reset-password/resend-otp",
    { loginId }
  );
  return res.data;
};

export const resetPassword = async (payload: {
  email: string;
  otp: string;
  newPassword: string;
  confirmPassword: string;
}) => {
  const res = await axiosInstance.post(
    "/User/reset-password/verify-otp",
    {
      loginId: payload.email,
      otp: payload.otp,
      newPassword: payload.newPassword,
      confirmPassword: payload.confirmPassword,
    }
  );

  return res.data;
};
